import { elementExists } from '../utils';
import { FreeShippingNotice } from './';

const InitFreeShippingNotices = (
  selector = '[cart-free-shipping-container]',
) => {
  const containers = Array.from(document.querySelectorAll(selector));

  if (elementExists(containers, true)) {
    containers.forEach((item) => {
      const shippingDataset = { ...item.dataset };
      const noticeContainer = item.querySelector('[cart-free-shipping-notice');
      const progressContainer = item.querySelector(
        '[cart-free-shipping-progress',
      );

      const items = {
        shippingDataset,
        noticeContainer,
        progressContainer,
      };

      FreeShippingNotice(items);
    });
  }
};

export default InitFreeShippingNotices;
